<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="域名状态"
  >
    <div class="content" v-if="data">
      <div class="row" style="background-color: #e8eaec">
        <div class="name flex" style="text-align: center">域名状态描述</div>
        <div class="label flex" style="text-align: center">域名状态码</div>
      </div>
      <div
        :class="['row', { 'row-border': index !== data.length - 1 }]"
        style="line-height: 50px"
        v-for="(item, index) in data"
        :key="item.name"
      >
        <div class="name flex" style="text-align: center">{{ item.desc }}</div>
        <div class="label flex" style="text-align: center">{{ item.name }}</div>
      </div>
    </div>
    <div class="foot">
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: "domainStatusModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    onCancel() {
      this.visibility = false;
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.row {
  display: flex;
  line-height: 40px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
  .name.flex,
  .label.flex {
    flex: 1;
  }
}
.row.row-border {
  border-bottom: 1px dashed #dcdee2;
}
</style>
